export default {
  open: state => state.open,
  conversationId: state => state.conversationId
};
